import markdownit from 'markdown-it';

function initMarkdownViewerComponent(app) {
    app.component('markdownViewer',
        {
            template: '#markdown-viewer-template',
            props: {
                value: {required: true},
            },
            data() {
                return {
                    html: this.toHtml(this.value.markdown),
                };
            },
            methods: {
                toHtml(markDown) {
                    if (!markDown) {
                        return markDown;
                    }
                    return markdownit().render(markDown);
                },
            },
        });
}

export default initMarkdownViewerComponent;
